/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-08-02 14:14:22
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-09-04 15:03:00
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { IMyOptions } from '../../interfaces/public-api';
@Component({
    selector: 'lib-selection-sidebar',
    templateUrl: './selection-sidebar.component.html',
    encapsulation: ViewEncapsulation.None
})
export class SelectionSidebarComponent {
    @Input() opts: IMyOptions;
    @Output() setTime: EventEmitter<void> = new EventEmitter<void>();
}
